/**
 * AI Model Process item state enumerator.
 */
export enum AIModelProcessState {
	New = "new",
	Processing = "processing",
	Completed = "completed",
	Error = "error"
}
